import LandingLoadingSpinner from '@web-platform/shared-universal-features-components/src/LandingLoadingSpinner';
import { LoadingSpinner } from '@web-platform/shared-universal-features-components/src/LoadingSpinner/LoadingSpinner';
import { isAcornRequest } from '@web-platform/shared-universal-utils-frontend/src/helpers/isAcornRequest';

type Props = {
  lastNavWasSoft: boolean;
  spinnerContainerClassName?: string;
};

export const RouterFallbackUI = ({ lastNavWasSoft, spinnerContainerClassName }: Props) =>
  isAcornRequest() || lastNavWasSoft ? (
    <LoadingSpinner spinnerClassName={isAcornRequest() ? spinnerContainerClassName : ''} />
  ) : (
    <LandingLoadingSpinner />
  );
